<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import 'assets/scss/vars/base';

* {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

:root {
  font-size: 16px;
}

@media (max-width: 900px) {
  :root {
    font-size: 8px;
  }
}

:focus {
  outline: 0;
}

html, body{
  margin: 0;
  padding: 0;
  height: 100%;
  font-size: 1rem;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  background: #11181d;
  -webkit-text-size-adjust: 100%;
}

#app {
  min-height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue